import { Grid, Group, Select, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";
import AdminInputField from "../../components/adminInputField";
import Button from "../../components/Button";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import PasswordField from "../../components/PasswordField";
import {
  emailRegex,
  nameRegex,
  passwordRegex,
  userNameRegex,
} from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";
import { addUser } from "./postData";

const AddUsers = ({
  opened,
  setOpened,
  userRoles,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      role: "",
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      cpassword: "",
    },

    validate: {
      role: (value) => (!value ? "Please select a role" : null),
      userName: (value) =>
        value?.trim()?.length > 1 && userNameRegex.test(value.trim())
          ? null
          : "Alphabetic Numeric UserName without Spaces",
      firstName: (value) =>
        value?.trim()?.length > 1 && nameRegex.test(value.trim())
          ? null
          : "Alphabetic Last Name with 2 or more characters",
      lastName: (value) =>
        value?.trim()?.length > 1 && nameRegex.test(value.trim())
          ? null
          : "Alphabetic First Name with 2 or more characters",
      email: (value) =>
        emailRegex.test(value?.trim()) ? null : "Invalid Email",
      password: (value) =>
        passwordRegex.test(value)
          ? null
          : "Must Contain 8 Characters, 1 Uppercase, 1 Lowercase, 1 Number, 1 Special Character",
      cpassword: (value, values) =>
        value === values.password ? null : "Passwords do not match",
    },
  });

  // useEffect(() => {
  //   form.setFieldValue("role", role);
  // }, [opened, form.values.role]);
  useEffect(() => {
    if (editModalState) {
      console.log("editData in add modal", editData);
      form.setFieldValue("role", editData.role._id);
      form.setFieldValue("userName", editData.userName);
      form.setFieldValue("firstName", editData.firstName);
      form.setFieldValue("lastName", editData.lastName);
      form.setFieldValue("email", editData.email);
      form.setFieldValue("password", "@Admin123");
      form.setFieldValue("cpassword", "@Admin123");
    }
  }, [opened, editModalState]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.userId = editData._id;
      url = "user/editUser";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "user/addUser";
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };
  const userRole = userRoles.map((role) => {
    return {
      label: role.name,
      value: role._id,
    };
  });

  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Grid justify="center">
        <Grid.Col md={12}>
          <Text mb={0} weight={500}>
            User Role
          </Text>
          <Select
            disabled={editModalState}
            styles={{
              input: {
                padding: "1.2rem",
              },
            }}
            required
            withAsterisk={false}
            placeholder="Select User Role"
            data={userRole}
            // disabled={form.values.role ? true : false}
            // searchable
            nothingFound="No User Role found"
            {...form.getInputProps("role")}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            First Name
          </Text>
          <AdminInputField
            width="100%"
            placeholder="Enter First Name"
            form={form}
            validateName="firstName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Last Name
          </Text>
          <AdminInputField
            width="100%"
            placeholder="Enter Last Name"
            form={form}
            validateName="lastName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            User Name
          </Text>
          <AdminInputField
            // label={"User Name"}
            width="100%"
            placeholder="Enter User Name"
            form={form}
            validateName="userName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Email
          </Text>
          <AdminInputField
            width="100%"
            disabled={editModalState}
            placeholder="Enter Email"
            form={form}
            validateName="email"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6} hidden={editModalState}>
          <Text mb={0} weight={500}>
            Password
          </Text>
          <PasswordField
            width="100%"
            placeholder="Enter Password"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onInput={(e) => {
              if (e.target.value !== form.values.cpassword) {
                form.setFieldError("cpassword", "Passwords Do Not Match");
              } else {
                form.setFieldError("cpassword", "");
              }
            }}
            form={form}
            validateName="password"
          />
        </Grid.Col>
        <Grid.Col md={6} hidden={editModalState}>
          <Text mb={0} weight={500}>
            Confirm Password
          </Text>
          <PasswordField
            width="100%"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            placeholder="Re-Enter Password"
            errorProps={(v) => {
              return v !== form.values.password;
            }}
            form={form}
            validateName="cpassword"
          />
        </Grid.Col>
      </Grid>

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Update" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );

  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      title={editModalState ? "Edit User" : "Add User"}
      InternalComponent={InternalContent}
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};

export default AddUsers;
